export const sanitizeImageUrl = (url = '') => url.replace(/<SIZE>/g, '400');